import React from "react";
import { FaRocket, FaUsers, FaShieldAlt, FaClock } from "react-icons/fa";

const items = [
  {
    icon: <FaRocket />,
    title: "Fast Delivery",
    desc: "Agile development with quick turnaround and on-time project delivery."
  },
  {
    icon: <FaUsers />,
    title: "Expert Team",
    desc: "Skilled developers, designers, and technology experts."
  },
  {
    icon: <FaShieldAlt />,
    title: "Secure Solutions",
    desc: "High standards of security, data protection, and reliability."
  },
  {
    icon: <FaClock />,
    title: "24/7 Support",
    desc: "Dedicated support and maintenance whenever you need it."
  }
];

const WhyChoose = () => {
  return (
    <section id="why">
      <h2>Why Choose Infobizz</h2>

      <div className="why-grid">
        {items.map((item, index) => (
          <div className="why-card" key={index}>
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;
